export default "__VITE_ASSET__BkQRTP1z__"